<template>
    <div class="topics-page">
      <DefaultHeader title="Топики для Telegram" />
  
      <div class="content">
        <!-- Add button -->
        <div class="add-button">
          <button @click="createTopic">+</button>
        </div>
  
        <!-- Loading shimmer -->
        <div v-if="isLoading" class="topics-list">
          <div v-for="n in 3" :key="n" class="topic-card shimmer">
            <div class="shimmer-line title"></div>
            <div class="shimmer-line meta"></div>
          </div>
        </div>
  
        <!-- Empty state -->
        <div v-else-if="topics.length === 0" class="empty-state">
          <div class="empty-title">Топиков пока нет</div>
          <div class="empty-subtitle">
            Создайте первый топик для публикации в Telegram
          </div>
        </div>
  
        <!-- Topics list -->
        <div v-else class="topics-list">
          <div
            v-for="topic in topics"
            :key="topic.id"
            class="topic-card"
          >
            <div class="topic-info">
              <div class="topic-title">
                {{ topic.title }}
              </div>
  
              <div class="topic-meta">
                <div>Создан {{ formatDate(topic.createdAt) }}</div>
                <div>Публикация {{ formatDate(topic.publishAt) }}</div>
              </div>
            </div>
  
            <div
              class="status-badge"
              :class="topic.status"
            >
              {{ topic.status === 'published'
                ? 'опубликован'
                : 'ожидает публикации' }}
            </div>
          </div>
        </div>
      </div>

    <CreateTelegramTopicDrawer
        v-if="showCreateDrawer"
        @close="showCreateDrawer = false"
        @created="reloadTopics"
    />
  
      <Footer />
    </div>
  </template>
  
  <script setup>

  import { ref, onMounted } from 'vue'
  
  import CreateTelegramTopicDrawer from '../views/CreateTelegramTopicDrawer.vue'
  import DefaultHeader from '../components/DefaultHeader.vue'
  import Footer from '../components/MiniFooter.vue'
  import AdminService from '../api/AdminService'
  import TelegramTopic from '../models/TelegramTopic'
  

  const topics = ref([])
  const isLoading = ref(true)
  const showCreateDrawer = ref(false)

  onMounted(async () => {
    try {
      const rawTopics = await AdminService.getAdminTelegramTopics()
      topics.value = rawTopics.map(t => TelegramTopic.fromJson(t))
    } catch (e) {
      console.error('❌ Ошибка загрузки топиков', e)
    } finally {
      isLoading.value = false
    }
  })
  
function createTopic() {
  showCreateDrawer.value = true
}

async function reloadTopics() {
  isLoading.value = true
  const raw = await AdminService.getAdminTelegramTopics()
  topics.value = raw.map(t => TelegramTopic.fromJson(t))
  isLoading.value = false
}
  
  function formatDate(date) {
    if (!date) return '—'
    return new Date(date).toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'long'
    })
  }
  </script>
  
  <style scoped>
  .topics-page {
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
  
  .content {
    margin-top: 60px;
    padding: 40px 20px;
    background: #f3f3f3;
    flex: 1;
  }
  
  .add-button {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }
  
  .add-button button {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: none;
    font-size: 26px;
    background: #2f6fed;
    color: white;
    cursor: pointer;
  }
  
  .topics-list {
    max-width: 700px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .topic-card {
    background: white;
    border-radius: 16px;
    padding: 20px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .topic-title {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 6px;
  }
  
  .topic-meta {
    font-size: 13px;
    color: #8a8a8a;
  }
  
  .status-badge {
    padding: 6px 14px;
    border-radius: 999px;
    font-size: 12px;
    white-space: nowrap;
  }
  
  .status-badge.published {
    background: #b8e05f;
    color: #2e4b00;
  }
  
  .status-badge.pending {
    background: #e0e0e0;
    color: #666;
  }
  
  /* Empty */
  .empty-state {
    text-align: center;
    margin-top: 80px;
  }
  
  .empty-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 6px;
  }
  
  .empty-subtitle {
    font-size: 14px;
    color: #777;
  }
  
  /* Shimmer */
  .shimmer {
    overflow: hidden;
    position: relative;
  }
  
  .shimmer::after {
    content: '';
    position: absolute;
    top: 0;
    left: -150px;
    height: 100%;
    width: 150px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255,255,255,0.6),
      transparent
    );
    animation: shimmer 1.2s infinite;
  }
  
  .shimmer-line {
    background: #e6e6e6;
    border-radius: 6px;
  }
  
  .shimmer-line.title {
    height: 16px;
    width: 260px;
    margin-bottom: 10px;
  }
  
  .shimmer-line.meta {
    height: 12px;
    width: 180px;
  }
  
  @keyframes shimmer {
    100% {
      transform: translateX(300px);
    }
  }
  </style>